import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicContactOrganisateur = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const isSmallDevise = windowWidth < 900;  
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: "S'inscrire des compétitions", link: '/topics/rechercher/sincrire-competition-index'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Pour contacter les organisateurs, rien de plus simple : rendez-vous sur la page de la compétition. Si un e-mail de contact a été publié, 
              cliquez dessus pour envoyer directement votre message. 
            </p>
            <p className="help-text">
              Si, pour des raisons de confidentialité, vous préférez éviter la communication par e-mail, vous pouvez contacter l'organisateur directement 
              via la messagerie instantanée sur les réseaux sociaux (notamment Instagram). Vous pouvez également nous
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>écrire,</a> et nous nous chargerons de 
              transmettre votre demande afin que vous obteniez une réponse dans les meilleurs délais.
            </p>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicContactOrganisateur